import { fromJS } from 'immutable';
import { valIn } from '@client/shared/utils/immutableUtils/immutableUtils';
import { fetchDonation } from '@client/connectivity/api.donation';
import { loadIndividualFundraiserCms } from '@client/pages/individualFundraiserPage/duckIndividualFundraiserPage';

export const DUCK_DONATE_PAGE_KEY = 'duckDonatePageReducer';

const LOAD_DONATE_PAGE_DONATION = 'LOAD_DONATE_PAGE_DONATION';

/* REDUCER */
let defaultState = fromJS({
  donation: null,
});

export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_DONATE_PAGE_DONATION: {
      return state.merge({
        donation: fromJS(action.payload),
        errorMessage: '',
      });
    }
    default:
      return state;
  }
}

/* ACTIONS */
export function loadDonation(donationId) {
  return function (dispatch) {
    return fetchDonation(donationId).then((response) => {
      return dispatch({
        type: LOAD_DONATE_PAGE_DONATION,
        payload: response.data,
      });
    });
  };
}

export function loadDonationPageData(donationId) {
  return function (dispatch) {
    const donatePromises = [
      dispatch(loadDonation(donationId)),
      dispatch(loadIndividualFundraiserCms()),
    ];
    return Promise.all(donatePromises);
  };
}

/* SELECTORS */
export const selectDonatePageDonation = (state) => {
  return valIn(state[DUCK_DONATE_PAGE_KEY], 'donation');
};
